const isNavOpen = ref(false)

export function useAppNav() {
  const appStore = useAppStore()

  const ownsDrawer = computed(() => !appStore.spotHopperEmbedded)

  const openNav = () => {
    if (!ownsDrawer.value) {
      window.parent.postMessage(
        'openSpothopperSidebar',
        import.meta.env.VITE_SH_URL,
      )
      return
    }

    isNavOpen.value = true
  }

  const closeNav = () => {
    isNavOpen.value = false
  }

  return { isNavOpen, ownsDrawer, openNav, closeNav }
}
